angular.module('core')
  .service('navigation', [
    '$rootScope',
    '$state',
    'authentication',
    'navigationTabsService',
    '$location',
    '$timeout',
    'configuration',
    '$q',
    'dblAnalyticsProvider',
    'edxPendingChangesModalService',
    function (
        $rootScope,
        $state,
        $authentication,
        $navigationTabs,
        $location,
        $timeout,
        $configuration,
        $q,
        dblAnalytics,
        edxPendingChangesModalService) {

        // remember where we are for route-state state-change-start events
        var currentView;

        // remember where we've been for route-state state-change-finish events
        var previousView;

        function finishPreviousTracking(timestamp) {
            var tracking = previousView.tracking;
            if (tracking) {
                tracking.trackingFinishTimestamp = timestamp;
                tracking.trackingDurationInMs = timestamp.getTime() - tracking.trackingStartTimestamp.getTime();
            }
        }

        function startNewTracking(viewLevel, view, timestamp) {
            var trackingPane = view.subpane ? view.subpane : view.pane;
            view.tracking = {
                trackingViewId: trackingPane + '-' + timestamp.getTime(),
                trackingStartTimestamp: timestamp,
                trackingFinishTimestamp: null,
                trackingDurationInMs: null
            };

            view.viewLevel = view.viewLevel || viewLevel;
        }

        function sendTrackingStartAndSetPrevious(view) {
            dblAnalytics.pageTrack($location.url(), $location, view);
            previousView = view;
        }

        function updateTracking(viewLevel, view) {
            var timestamp = new Date();
            if (previousView) {
                finishPreviousTracking(timestamp);
            }

            startNewTracking(viewLevel, view, timestamp);
        }

        // Used for page tracking from router $stateChangeStart
        function routeStateFinish(viewLevel, view) {
            currentView = _.cloneDeep(view);
            updateTracking(viewLevel, currentView);
            if (previousView && previousView.tracking && previousView.tracking.trackingFinishTimestamp) {
                dblAnalytics.pageTrack($location.url(), undefined, undefined, previousView);
            }
        }

        // Used for page tracking from router $stateChangeSuccess
        function routeStateStart(viewLevel, view) {
            // expect that currentView was set in routeStateFinish, but if not, set it here
            if (!currentView) {
                currentView = _.cloneDeep(view);
            }
            sendTrackingStartAndSetPrevious(currentView);
        }

        // Page tracking for non-notifying state transitions, as is needed
        // for settings tab changes, and in particular when teacher settings modal tabs are clicked.
        function updateRouteState(viewLevel, params, options) {
            var previousUrl = $location.url();

            $state.go('.', params, options).then(function () {
                var timestamp = new Date();
                var currentView = _.extend(_.cloneDeep($state.params), params);
                if (previousView) {
                    if (currentView.pane !== previousView.pane || currentView.subpane !== previousView.subpane) {
                        finishPreviousTracking(timestamp);
                        if (previousView.tracking && previousView.tracking.trackingFinishTimestamp) {
                            dblAnalytics.pageTrack(previousUrl, undefined, undefined, previousView);
                        }

                        startNewTracking(viewLevel, currentView, timestamp);
                        sendTrackingStartAndSetPrevious(currentView);
                    }
                }
            });
        }

        var toShortFormat = function (longFormat) {
            switch (longFormat) {
                case 'district':
                    return 'd';
                case 'grade':
                    return 'g';
                case 'school':
                    return 'sc';
                case 'teacher':
                    return 't';
                case 'classroom':
                    return 'c';
                case 'student':
                    return 'st';
                case 'guardian':
                    return 'g';
            }
        };

        var toLongFormat = function (shortFormat) {
            switch (shortFormat) {
                case 'd':
                    return 'district';
                case 'g':
                    return 'grade';
                case 'sc':
                    return 'school';
                case 't':
                    return 'teacher';
                case 'c':
                    return 'classroom';
                case 'st':
                    return 'student';
                case 'g':
                    return 'guardian';
            }
        };

        var getBreadcrumbOrder = function (order) {
            if (!order) {
                return;
            }
            var result = _.map(order.split(','), function (shortFormat) {
                return toLongFormat(shortFormat);
            });
            //Drop the district from the breadcrumbs
            result = _.drop(result, 1);
            return result;
        };

        /**
         * Update's the state params for 'grade' and 'school' state. When navigating back
         * schoolId or gradeId may need to be removed depending on their order.
         * @param  {String} type The selected item's type
         * @return {undefined}      nothing
         */
        // var updateIdParams = function(params, currentOrder) {
        //   var breadcrumbOrder = $navigation.getBreadcrumbOrder(currentOrder);
        //   if(stateName === 'grade' && _.indexOf(breadcrumbOrder, 'grade') < _.indexOf(breadcrumbOrder, 'school') && _.indexOf(breadcrumbOrder, 'grade') !== -1) {
        //     $state.params.schoolId = null;
        //   }
        //   else if(stateName === 'school' && _.indexOf(breadcrumbOrder, 'school') < _.indexOf(breadcrumbOrder, 'grade') && _.indexOf(breadcrumbOrder, 'school') !== -1) {
        //     $state.params.gradeId = null;
        //   }
        // };

        var updateParamsByOrder = function (params) {
            var breadcrumbOrder = getBreadcrumbOrder(params.breadcrumbs);
            var paramKeys = _.map(breadcrumbOrder, function (type) {
                return type + 'Id';
            });
            paramKeys.push('districtId');
            paramKeys.push('pane');
            paramKeys.push('edit');

            paramKeys.push('breadcrumbs');
            paramKeys.push('timeframe');
            paramKeys.push('timeframeId');
            paramKeys.push('by');
            if (params.pane === 'standards') {
                paramKeys.push('standards');
            }
            return _.pick(params, paramKeys);

        };

        var updateBreadcrumbOrder = function (currentOrder, stateName) {
            var order = [];
            if (currentOrder) {
                order = currentOrder.split(',');
            }
            var newOrderItem = toShortFormat(stateName);
            if (_.indexOf(order, newOrderItem) !== -1) {

                order = _.dropRightWhile(order, function (item) {
                    return item !== newOrderItem;
                });
            } else {
                order.push(newOrderItem);
            }

            // if classroom is after student in breadcrumbs, remove student from the breadcrumb
            var classroomIndex = _.indexOf(order, toShortFormat('classroom'));
            var studentIndex = _.indexOf(order, toShortFormat('student'));
            if ((classroomIndex > studentIndex) && (studentIndex >= 0)) {
                order.splice(studentIndex, 1);
            }
            return order.toString();
        };

        var validateNumeric = function (params, paramName) {
            return _.has(params, paramName) && $.isNumeric(params[paramName]);
        };

        var validateParameters = function (params, stateName) {
            switch (stateName) {
                case 'student':
                    return validateNumeric(params, 'studentId') && validateNumeric(params, 'teacherId') && validateNumeric(params, 'schoolId') && validateNumeric(params, 'districtId');
                case 'classroom':
                    return validateNumeric(params, 'classroomId') && validateNumeric(params, 'teacherId') && validateNumeric(params, 'schoolId') && validateNumeric(params, 'districtId') && !_.has(params, 'studentId');
                case 'guardian':
                    return validateNumeric(params, 'districtId') && validateNumeric(params, 'customerId');
                case 'teacher':
                    return validateNumeric(params, 'teacherId') && validateNumeric(params, 'schoolId') && validateNumeric(params, 'districtId') && !_.has(params, 'classroomId') && !_.has(params, 'studentId');
                case 'school':
                    return validateNumeric(params, 'schoolId') && validateNumeric(params, 'districtId') && !_.has(params, 'classroomId') && !_.has(params, 'teacherId') && !_.has(params, 'studentId');
                case 'grade':
                    return validateNumeric(params, 'gradeId') && validateNumeric(params, 'districtId') && !_.has(params, 'classroomId') && !_.has(params, 'teacherId') && !_.has(params, 'studentId');
                case 'district':
                    return validateNumeric(params, 'districtId') && !_.has(params, 'classroomId') && !_.has(params, 'teacherId') && !_.has(params, 'schoolId') && !_.has(params, 'gradeId') && !_.has(params, 'studentId');
                default:
                    return false;
            }
        };

        /**
         * Wrapper around router state navigation allowing us block state changes
         * before they are initiated.
         *
         * @param string state
         * @param {*} params
         */
        var go = function (state, params) {
            if (edxPendingChangesModalService.isPending()) {
                var modalResult = edxPendingChangesModalService.open();

                modalResult.then(function () {
                    $state.go(state, params);
                });
            } else {
                $state.go(state, params);
            }
        };

        /**
         * Sets the url and relies on the 'otherwise' state and authentication
         * service to redirect to the customer's home page
         * @return {undefined}
         */
        var _goHome = function () {
            $location.url('/customer_home');
        };

        var goHome = function () {
            if (edxPendingChangesModalService.isPending()) {
                var modalResult = edxPendingChangesModalService.open();

                modalResult.then(function () {
                    _goHome();
                });
            } else {
                _goHome();
            }
        };



        /**
         * Navigate to the view for the specified item.
         **/
        var goToItem = function (item, overrideParams, options) {
            handleRoute(undefined, item, overrideParams, options);
        };

      /**
       * Builds a link to the state for the given item
       *
       * This is analygous to goToItem() except it generates a link instead of immediately changing the page.
       *
       * @param item The item to link to
       * @param overrideParams Parameters for the new state
       * @param options Options for the transition
       */
        function href(item, overrideParams, options) {
          var params = angular.copy($state.params);
          var typeId = item.type + 'Id';
          var stateName = item.type;

          params[typeId] = item.id;

          params.breadcrumbs = updateBreadcrumbOrder(params.breadcrumbs, stateName);
          params = updateParamsByOrder(params);
          params.pane = $navigationTabs.getTabSlug(stateName, params.assign, params);
          if (!options || !options.keepStandards) {
            params.standards = null; // reset standards
          }

          if (overrideParams) {
            angular.extend(params, overrideParams);
          }

          return $state.href(stateName, params);
        }

        var handleRoute = function (e, item, overrideParams, options) {
            var params = angular.copy($state.params);
            var typeId = item.type + 'Id';
            var stateName = item.type;

            params[typeId] = item.id;

            // TODO: here is the place to start in on the district/invalid route for better default route option
            // if (toParams.id === "invalid") {
            //    e.preventDefault();
            //    // TODO: route them here based on role
            //    console.log(' bad url - need to re-route');
            //    return null;
            //  }
            // For more granular control add ng-show = $rootScope.customer.policy[toState.name]
            // right on the partial in info-pane.html / right-pane.html

            params.breadcrumbs = updateBreadcrumbOrder(params.breadcrumbs, stateName);
            params = updateParamsByOrder(params);
            params.pane = $navigationTabs.getTabSlug(stateName, params.assign, params);
            if (!options || !options.keepStandards) {
                params.standards = null; // reset standards
            }

            if (overrideParams) {
                angular.extend(params, overrideParams);
            }

            $state.go(stateName, params);
        };

        var tryNavigate = function () {
            var deferred = $q.defer();
            if (!edxPendingChangesModalService.isPending()) {
                // no changes, just resolve
                deferred.resolve({});
            } else {
                edxPendingChangesModalService.open().then(function () {
                    // discard edits
                    deferred.resolve({});
                }, function () {
                    // stay on current page
                    deferred.reject({});
                });
            }
            return deferred.promise;
        };

        $rootScope.$on('route', handleRoute);

        $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {
            // All states require login.  Would prefer doing this in top level
            // controller/component vs in this event, but this is convenient for the time
            // being.
            if (!$authentication.isLoggedIn()) {
                e.preventDefault();
                $authentication.simulateLogin().then(function () {
                    $state.go(toState.name, toParams);
                });
                return;
            }

            if (toState.parent === 'report') {

                // This code breaks page reload and deep linking for tabs that are visible based on customer properties.
                // Bypassing for Classroom At Glance and third-party assessments until we can get a better fix which
                // could be as simple as moving the $authentication.isLoggedIn() check to the beginning of this function.
                //
                // This code breaks the Create Assignment (NWEA) tab.  This code checks to see if the target pane is
                // valid and selects a default pane if not.  This code needs to run synchronously, but we don't know if
                // the Create Assignment (NWEA) tab is valid until we asynchronously load the effective profile setting.
                // This code always sees the Create Assignment (NWEA) pane as invalid.
                var ignoreList = ['alerts','create_nwea_assignment', 'create_quantile_assignment'];
                if (ignoreList.indexOf(toParams.pane) === -1) {
                    // if the provided tab slug is not valid for the current state
                    var tabSlug = $navigationTabs.getTabSlug(toState.name, toParams.assign, toParams);
                    if (tabSlug !== toParams.pane) {
                        // we have to select the default one
                        toParams.pane = tabSlug;
                        if (!tabSlug) {
                            toParams.pane = $navigationTabs.getTabSlug(toState.name, toParams.assign, toParams);
                        }
                    }

                    if (typeof toParams.pane !== 'undefined') {
                        $navigationTabs.setActiveTabBySlug(toParams.pane);
                    }
                }
            }



            if (toState.parent === 'report') {
                if (!validateParameters(toParams, toState.name)) {
                    console.log('Invalid parameters!', toState.name, toParams);
                    e.preventDefault();
                    $timeout(_goHome);
                    return;
                }

                if (!$authentication.validatePolicy(toParams, toState.name)) {
                    console.log('Unauthorized access!', toState.name, toParams);
                    e.preventDefault();
                    $timeout(_goHome);
                    return;
                }
            }
        });

        return {
            toShortFormat: toShortFormat,
            toLongFormat: toLongFormat,
            updateBreadcrumbOrder: updateBreadcrumbOrder,
            validateParameters: validateParameters,
            getBreadcrumbOrder: getBreadcrumbOrder,
            handleRoute: handleRoute,
            go: go,
            goHome: goHome,
            goToItem: goToItem,

            tryNavigate: tryNavigate,
            routeStateFinish: routeStateFinish,
            routeStateStart: routeStateStart,
            updateRouteState: updateRouteState,
            href: href
        };

    }
]);
